import React, { useState } from 'react';

import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { ToggleButton } from '@/components/Elements/ToggleButton';
import Utils from '@/utils/util';

export type PhotoGallerrProps = {
  petsGalaryList?: any;
  onChangeList: (active: any) => void;
  hideToggle?: boolean | undefined;
};
export const PhotoGallerr = ({
  petsGalaryList,
  onChangeList,
  hideToggle
}: PhotoGallerrProps) => {
  const onToggleChange = () => { onToggleChange() };
  const [isChecked, setIsChecked] = useState<any>(false)

  return (
    <>
      <div className="gallery-bottom">
        {!hideToggle && <> <div className="toggle-action">
          <label className="form-label">Photo Memories</label>
          <span className="toggle after-font-color">
            After Service Only <ToggleButton isChecked={isChecked}
              onChange={(active) => {
                setIsChecked(active)
                onChangeList(active);
              }} />
          </span>
        </div>
          <hr className="seperator" /> 
        </>}

        <div className="gallery">
          <ResponsiveMasonry columnsCountBreakPoints={{ 350: 2, 750: 2, 900: 3 }}>
            <Masonry columnsCount={3} gutter={'10px'}>
              {petsGalaryList && petsGalaryList.length > 0 && [...petsGalaryList]
                .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).map((item: any) => {
                  return (
                    <div className="gallery-item">
                      {item?.isAfter && <div className='is-after'><p>After</p></div>}
                      <img src={item.imageUrl} />
                      <p>{Utils.timeAgo(item?.createdAt)}</p>
                    </div>
                  )
                })}
              {/* <div className="gallery-item">
                <img src="https://c4.staticflickr.com/9/8887/28897124891_98c4fdd82b_b.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://i.imgur.com/OB0y6MR.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://c2.staticflickr.com/9/8817/28973449265_07e3aa5d2e_b.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://farm1.staticflickr.com/49/157534104_95ca4e0ae6.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://farm7.staticflickr.com/6089/6115759179_86316c08ff_z_d.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://farm4.staticflickr.com/3224/3081748027_0ee3d59fea_z_d.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://c2.staticflickr.com/9/8817/28973449265_07e3aa5d2e_b.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://farm1.staticflickr.com/49/157534104_95ca4e0ae6.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://farm7.staticflickr.com/6089/6115759179_86316c08ff_z_d.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://farm4.staticflickr.com/3224/3081748027_0ee3d59fea_z_d.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://c2.staticflickr.com/9/8817/28973449265_07e3aa5d2e_b.jpg" />
                <p>2 days ago</p>
              </div>
              <div className="gallery-item">
                <img src="https://farm1.staticflickr.com/49/157534104_95ca4e0ae6.jpg" />
                <p>2 days ago</p>
              </div> */}
            </Masonry>
          </ResponsiveMasonry>
        </div>
        {hideToggle && petsGalaryList && petsGalaryList.length === 0 &&
          (
            <div
              className={`insurance-top-section notsubmitted`}
            >
              <span className={`status notsubmited`}>
                {'No Photos available'}
              </span>
            </div>
          )}
        {!hideToggle && <div className='footer-shaddow'></div>}
      </div>
    </>
  );
}
